<template>
  <v-simple-table>
    <template v-slot:default>
      <thead>
      <tr>
        <th class="text-left" v-for="(header, key) in headers" :key="key">
          {{ header }}
        </th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item, itemKey) in items" :key="itemKey">
        <td v-for="(header, key) in headers" :key="key+'h'">
          <v-icon v-if="(item[key] === true)">mdi-checkbox-marked-circle-outline</v-icon>
          <span v-else-if="item[key]!==false">{{ item[key] }}</span>
          <span v-if="key==='actions'">
          <v-icon class="pointer" @click="$emit('editAction', item.id)">
            mdi-clipboard-edit-outline
          </v-icon>
          <v-icon class="pointer" @click="$emit('deleteAction', item.id)">
            mdi-trash-can-outline
          </v-icon>
          </span>
        </td>
      </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>

<script>
export default {
  name: 'SimpleTable',
  props: ['headers', 'items', 'showActions'],
  data() {
    return {
      desserts: [
        {
          name: 'Frozen Yogurt',
          calories: 159,
        },
        {
          name: 'Ice cream sandwich',
          calories: 237,
        },
        {
          name: 'Eclair',
          calories: 262,
        },
        {
          name: 'Cupcake',
          calories: 305,
        },
        {
          name: 'Gingerbread',
          calories: 356,
        },
        {
          name: 'Jelly bean',
          calories: 375,
        },
        {
          name: 'Lollipop',
          calories: 392,
        },
        {
          name: 'Honeycomb',
          calories: 408,
        },
        {
          name: 'Donut',
          calories: 452,
        },
        {
          name: 'KitKat',
          calories: 518,
        },
      ],
    };
  },
};
</script>

<style scoped>

</style>
